import { lazyLoad } from "utils/loadable";

const AssignmentsPage = lazyLoad(
  () => import("./index"),
  (module) => module.AssignmentsPage,
  {
    fallback: (
      <div>
        <p>Loading....</p>
      </div>
    ),
  }
);

export default AssignmentsPage;
